/* eslint-disable */
export const SCOPE = 'data:dimensionList';

export const INIT = `${SCOPE}/INIT`;
export const FETCHING = `${SCOPE}/FETCHING`;
export const FETCHING_SUCCESS = `${SCOPE}/FETCHING_SUCCESS`;
